const parseDateIntoIsoString = (dateString) => {
    const [datePart, timePart] = dateString.split(' ')

    const [month, day, year] = datePart.split('-')

    const isoString = `${year}-${month}-${day}T${timePart}:00`

    return new Date(isoString)
}

export default parseDateIntoIsoString
